var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PasswordStrengthMeter } from '../../password-strength-meter/password-strength-meter';
import { containsLowerCaseRegex, containsNumericRegex, containsUpperCaseRegex, } from '../../../models';
import { useEffect } from 'react';
import { useState } from 'react';
import { PasswordStrength } from '../../password-strength-meter/models/PasswordStrength';
import { FormInput } from '../form-input/form-input';
import Typography from '../../typography/typography';
export var PasswordInput = function (_a) {
    var nameProp = _a.nameProp, register = _a.register, className = _a.className, visible = _a.visible, label = _a.label, testId = _a.testId, disabled = _a.disabled, value = _a.value, placeholder = _a.placeholder, sufficIconColor = _a.sufficIconColor, error = _a.error, _b = _a.strengthMeterVisible, strengthMeterVisible = _b === void 0 ? false : _b;
    var _c = useState('password'), inputType = _c[0], setInputType = _c[1];
    var _d = useState('EyeIcon'), suffixIcon = _d[0], setSuffixIcon = _d[1];
    var _e = useState(PasswordStrength.none), passwordMeterType = _e[0], setPasswordMeterType = _e[1];
    var _f = useState({
        characterCount: false,
        uppercase: false,
        lowercase: false,
        numeric: false,
    }), passwordConstraintMessage = _f[0], setPasswordConstraintMessage = _f[1];
    var _g = useState(''), passwordMeterMessage = _g[0], setPasswordMeterMessage = _g[1];
    var _h = useState(false), passwordMeterVisibility = _h[0], setPasswordMeterVisibility = _h[1];
    var updateIcon = function (fieldType) {
        var newFieldType = fieldType === 'password' ? 'text' : 'password';
        var newFieldIcon = newFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
        setInputType(newFieldType);
        setSuffixIcon(newFieldIcon);
    };
    useEffect(function () {
        if (value && value.length > 0) {
            setPasswordMeterVisibility(true);
        }
        var passwordChangedEvent = getPasswordLevel(value);
        setPasswordMeterType(passwordChangedEvent.type);
    }, [value]);
    var getPasswordLevel = function (value) {
        var defaultReturnValue = {
            type: PasswordStrength.none,
            message: '',
        };
        if (value && value.length === 0) {
            return defaultReturnValue;
        }
        var errorCount = 4;
        var passwordMessage = null;
        if (value.match(containsLowerCaseRegex)) {
            errorCount -= 1;
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { lowercase: true })); });
        }
        else {
            passwordMessage = 'Password must contain at least 1 lowercase character';
            setPasswordMeterMessage(passwordMessage);
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { lowercase: false })); });
        }
        if (value.match(containsUpperCaseRegex)) {
            errorCount -= 1;
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { uppercase: true })); });
            if (!passwordMessage) {
                setPasswordMeterMessage('');
            }
        }
        else {
            passwordMessage = 'Password must contain at least 1 uppercase character';
            setPasswordMeterMessage(passwordMessage);
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { uppercase: false })); });
        }
        if (value.match(containsNumericRegex)) {
            errorCount -= 1;
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { numeric: true })); });
            if (!passwordMessage) {
                setPasswordMeterMessage('');
            }
        }
        else {
            passwordMessage = 'Password must contain at least 1 numeric character';
            setPasswordMeterMessage(passwordMessage);
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { numeric: false })); });
        }
        if (value.length >= 8) {
            errorCount -= 1;
            setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { characterCount: true })); });
            if (!passwordMessage) {
                setPasswordMeterMessage('');
            }
        }
        else {
            if (value.length > 0) {
                passwordMessage = 'Password must be at least 8 characters';
                setPasswordMeterMessage(passwordMessage);
                setPasswordConstraintMessage(function (curr) { return (__assign(__assign({}, curr), { characterCount: false })); });
            }
        }
        if (errorCount === 0) {
            defaultReturnValue.type = PasswordStrength.veryGood;
            setPasswordMeterMessage('Very Good');
        }
        else if (errorCount === 1 || errorCount === 2) {
            defaultReturnValue.type = PasswordStrength.weak;
        }
        else if (errorCount === 3) {
            defaultReturnValue.type = PasswordStrength.error;
        }
        else if (errorCount === 4 && value.length === 0) {
            defaultReturnValue.type = PasswordStrength.none;
        }
        else if (errorCount === 4 && value.length > 0) {
            defaultReturnValue.type = PasswordStrength.error;
        }
        return defaultReturnValue;
    };
    return (_jsxs(_Fragment, { children: [_jsx("label", __assign({ htmlFor: nameProp, className: "font-body text-textMid block text-base font-semibold leading-snug" }, { children: label })), strengthMeterVisible &&
                Object.values(passwordConstraintMessage).some(function (a) { return !a; }) && (_jsxs("ul", __assign({ className: "text-textMid mb-4 list-disc pl-5" }, { children: [!passwordConstraintMessage.characterCount && (_jsx("li", { children: _jsx(Typography, { text: 'At least 8 characters', type: 'help', color: 'textMid' }) })), !passwordConstraintMessage.numeric && (_jsx("li", { children: _jsx(Typography, { text: 'At least 1 number', type: 'help', color: 'textMid' }) })), !passwordConstraintMessage.uppercase && (_jsx("li", { children: _jsx(Typography, { text: 'At least 1 capital letter', type: 'help', color: 'textMid' }) })), !passwordConstraintMessage.lowercase && (_jsx("li", { children: _jsx(Typography, { text: 'At least 1 lowercase letter', type: 'help', color: 'textMid' }) }))] }))), _jsxs("div", __assign({ className: className, "data-testid": testId }, { children: [_jsx(FormInput, { className: "mb-1", visible: visible, nameProp: nameProp, register: register, disabled: disabled, error: error, placeholder: placeholder, type: inputType, suffixIcon: suffixIcon, sufficIconColor: sufficIconColor, suffixIconAction: function () {
                            updateIcon(inputType);
                        } }), strengthMeterVisible &&
                        passwordMeterVisibility &&
                        value.length > 0 && (_jsx(PasswordStrengthMeter, { type: passwordMeterType, message: passwordMeterMessage }))] }))] }));
};
//# sourceMappingURL=password-input.js.map